import { Link } from "office-ui-fabric-react"

const SyncSettingsTooltip = () => {
    return <div>
        Define the exact day-to-day time when the sync on projects connected with external systems will take place.
        <br />
        Select the recipients to send the 'data synchronization failed' email, if needed.
        <br />
        Please refer to the <Link href="https://help.ppm.express/89495-ppm-express-settings/522610" target="_blank">article</Link> for more details.
    </div>
}

export default SyncSettingsTooltip;